import { t } from '@lingui/core/macro';
import { PropsWithChildren } from 'react';

const MAIN_CONTENT_ID = 'main-content';

export const SkipToMainContent = () => (
  <a
    href={`#${MAIN_CONTENT_ID}`}
    className='sr-only focus:not-sr-only focus:fixed focus:top-2 focus:left-2 focus:z-overlay focus:rounded-md focus:bg-white focus:px-3 focus:py-2 focus:text-black focus:shadow'
    onClick={() => {
      // The hash moves the scroll position. Main is not a control, so it only
      // takes focus when we ask it to.
      document.getElementById(MAIN_CONTENT_ID)?.focus();
    }}
  >
    {t`Skip to main content`}
  </a>
);

export const MainContent = ({ children }: PropsWithChildren) => (
  <main id={MAIN_CONTENT_ID} tabIndex={-1} className='focus:outline-hidden'>
    {children}
  </main>
);

/** Skip target for a page whose landmark is already a `<main>`, such as the sidebar inset. */
export const SkipContentTarget = ({ children }: PropsWithChildren) => (
  <div id={MAIN_CONTENT_ID} tabIndex={-1} className='focus:outline-hidden'>
    {children}
  </div>
);
